import { useMatch, useParams } from "react-router-dom";
import useNavigateKeepSearchParams from "../../../hooks/useNavigateKeepSearchParams";

// Custom hook to help control map edit mode
export const useMapEditing = () => {
  const navigate = useNavigateKeepSearchParams(["return_to"]);
  const { jobId, season } = useParams();

  const matches = useMatch({
    path: "/admin/property/:jobId/site-map/:season/edit",
    caseSensitive: false,
    end: false,
  });

  return {
    editing: Boolean(matches) ?? false,
    setEditing: (shouldEdit, extraUrl = "") => {
      navigate(
        shouldEdit
          ? `/admin/property/${jobId}/site-map/${season}/edit${extraUrl}`
          : "..",
      );
    },
  };
};
